<ion-card color="light" class="my-item ion-no-margin">
  <ion-grid class="ion-no-padding">
    <ion-row class="ion-padding-horizontal">
      <ion-col size="12" style="padding-bottom: 0">
        <ion-text color="medium" class="label">Customer Details</ion-text>
      </ion-col>
      <ion-col size="12">
        <ion-text class="text-medium font-bold" color="dark">{{
          customer?.name
        }}</ion-text>
        <div style="line-height: 17px" *ngIf="location">
          <ion-text
            [pTooltip]="location?.addressInfo | address"
            tooltipStyleClass="tooltip-bg-white"
            color="medium"
            class="text-regular address-box line-2"
            margin-bottom
            >{{ location?.addressInfo | address }}</ion-text
          >
        </div>
      </ion-col>
      <ion-col size="12" class="text-medium">
        <ion-row class="ion-align-items-center">
          <ion-icon
            [src]="'./assets/call-icon.svg'"
            color="dark"
            class="ion-float-left icon-padding"
          ></ion-icon>
          <ion-text color="dark" text-medium="">{{
            saleOrder
              ? customer?.mobile
              : orderType === "PICKUP"
              ? customer?.contactNumber
              : customer?.mobile
          }}</ion-text>
        </ion-row>
        <ion-row class="ion-align-items-center" *ngIf="customer?.email">
          <ion-icon
            [src]="'./assets/email_icon.svg'"
            color="dark"
            class="ion-float-left icon-padding"
          ></ion-icon>
          <ion-text color="dark" text-medium>{{ customer?.email }}</ion-text>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card>
